import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dragger, Button, Icon } from 'components/ui';
import { getFileData } from 'services/file';
import { getPublicUrl } from 'services/env-service';

class UploadCsvFile extends Component {
  state = {
    files: [],
    isUploading: false,
  };

  componentDidUpdate(prevProps) {
    this.resetOnTemplateChange(prevProps);
  }

  resetOnTemplateChange = prevProps => {
    if (prevProps.templateId !== this.props.templateId) {
      this.reset();
    }
  };

  reset = () => {
    this.setState({ files: [] });
  };

  getFileData = async file => {
    const fileClone = new File([file], file.name);
    const { data = {}, noOfRows = 0 } = await getFileData(fileClone);
    return { data, noOfRows, file };
  };

  handleFileUpload = async file => {
    const files = file ? [file] : [];
    this.setState({ files, isUploading: true });
    const fileData = await this.getFileData(file);
    this.setState({ isUploading: false });
    this.sendUpstream(fileData);
  };

  handleBeforeFileUpload = file => {
    this.handleFileUpload(file);
    return false;
  };

  handleOnFileRemove = () => {
    const files = [];
    const variables = [];
    this.setState({ files });
    this.sendUpstream(variables);
  };

  sendUpstream = variables => {
    this.props.onUpdateRecipients(variables);
  };

  render() {
    const { files, isUploading } = this.state;
    const { isMultiMode } = this.props;
    const PUBLIC_URL = getPublicUrl();

    return (
      <div className="upload-csv-file">
        <Dragger
          accept=".csv"
          beforeUpload={this.handleBeforeFileUpload} // eslint-disable-line react/jsx-handler-names
          className="upload-csv-file__dragger"
          fileList={files}
          multiple={false}
          size="small"
          onRemove={this.handleOnFileRemove}
        >
          Drop a CSV file here
          <br />
          or
          <br />
          <Button className="upload-csv-file__upload-btn" size="small">
            <Icon type={isUploading ? 'loading' : 'upload'} />
            <span className="upload-csv-file__btn-text">
              &nbsp; Click to upload file
            </span>
          </Button>
        </Dragger>
        <div className="upload-csv-file__sample-csv-file">
          Download a&nbsp;
          <a
            href={
              this.props.recommendations
                ? this.props.recommendationsType === 'jd'
                  ? `${PUBLIC_URL}/recommendations_jd_sample.csv`
                  : `${PUBLIC_URL}/recommendations_sample.csv`
                : isMultiMode
                ? `${PUBLIC_URL}/multi-campaign-sample-variables-file.csv`
                : `${PUBLIC_URL}/Sample-variables-file.csv`
            }
            target="blank"
          >
            sample csv file
          </a>
        </div>
      </div>
    );
  }
}

UploadCsvFile.defaultProps = {
  templateId: -1,
};

UploadCsvFile.propTypes = {
  templateId: PropTypes.number,
  onUpdateRecipients: PropTypes.func.isRequired,
  recommendations: PropTypes.bool,
  isMultiMode: PropTypes.bool,
  recommendationsType: PropTypes.string,
};

export default UploadCsvFile;
